export const PROVIDER_TAG_TYPES = 'PROVIDER_API';
